import { Component, computed, inject, input } from '@angular/core';
import { CurrencyFormatPipe } from '@zayan-erp/shared';
import { DsmLotIncentiveService } from '../../../services/dsm-lot-incentive.service';
import { SkeletonModule } from '@openng/optimus-ui/skeleton';
import { ButtonModule } from '@openng/optimus-ui/button';
import { ProgressBarModule } from '@openng/optimus-ui/progressbar';

@Component({
  selector: 'dsm-deal-incentive-pool-banner',
  standalone: true,
  imports: [CurrencyFormatPipe, SkeletonModule, ButtonModule, ProgressBarModule],
  templateUrl: './dsm-deal-incentive-pool-banner.component.html',
  styleUrl: './dsm-deal-incentive-pool-banner.component.scss'
})
export class DsmDealIncentivePoolBannerComponent {
  readonly bucketLabel = input('Addendum Products bucket');

  readonly #incentiveService = inject(DsmLotIncentiveService);

  isLoading = this.#incentiveService.isIncentiveLoading;
  hasError = computed(() => !!this.#incentiveService.incentiveError());
  errorMessage = computed(() => 'Unable to load incentive pool. Please try again.');
  total = this.#incentiveService.incentiveTotal;
  applied = this.#incentiveService.incentiveApplied;
  available = this.#incentiveService.incentiveRemaining;

  percentageUsed = computed(() => {
    const total = this.total();
    if (!total) return 0;
    return Math.min(100, Math.round((this.applied() / total) * 100));
  });

  retry(): void {
    this.#incentiveService.reloadLotIncentive();
  }
}
